/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Slugminlength3Inputs */

const zh_organizationsettings_slugminlength3 = /** @type {(inputs: Organizationsettings_Slugminlength3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标识至少需要2个字符`)
};

const en_organizationsettings_slugminlength3 = /** @type {(inputs: Organizationsettings_Slugminlength3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug must be at least 2 characters`)
};

const es_organizationsettings_slugminlength3 = /** @type {(inputs: Organizationsettings_Slugminlength3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El slug debe tener al menos 2 caracteres`)
};

/**
* | output |
* | --- |
* | "Slug must be at least 2 characters" |
*
* @param {Organizationsettings_Slugminlength3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_slugminlength3 = /** @type {((inputs?: Organizationsettings_Slugminlength3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Slugminlength3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_slugminlength3(inputs)
	if (locale === "en") return en_organizationsettings_slugminlength3(inputs)
	return es_organizationsettings_slugminlength3(inputs)
});
export { organizationsettings_slugminlength3 as "organizationSettings_slugMinLength" }